import React from 'react'
import styles from '../header.module.less'
import classnames from 'classnames'

const Right = ({ id, className, children, ...rest }) => {
  const style = classnames(styles.right, className, {
    'kiosk-color--brand-contrast-color': true,
  })
  return (
    <div id={id} className={style} {...rest}>
      {children}
    </div>
  )
}

export default Right
